export default __webpack_public_path__ + "static/media/another_booking.0c8543a2.svg";